import { FC } from "react";

const AISection: FC = () => {
  return (
    <section className="bg-blue-600 text-white text-center py-6 px-6 rounded-xl max-w-[80%] mx-auto">
      <p className="text-sm uppercase tracking-wider">Amplíe los horizontes de su negocio</p>
      <h2 className="text-[20px] md:text-[36px] font-bold mt-2 w-full">
        Automatice su negocio con <br /> inteligencia artificial
      </h2>
      <button className="mt-4 px-6 py-2 bg-white text-gray-800 font-semibold rounded-lg shadow-md hover:bg-gray-200 transition">
        VAMOS A HABLAR
      </button>
    </section>
  );
};

export default AISection;
